import React from "react";

const FaqSection = () => {
  return (
    < section className="bg-blue py-12" id="faq">
  <div className="max-w-6xl mx-auto px-4">
    <h2 className="text-xl font-bold italic text-center mb-10">
      ❓ Frequently Asked Questions
    </h2>
    
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <div className="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
        <h4 className="font-semibold text-gray-900">💰 Is it free to use LeagueSphere?</h4>
        <p className="text-gray-700 mt-2">Yes! You can start creating and managing tournaments for free.</p>
      </div>

      <div className="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
        <h4 className="font-semibold text-gray-900">📱 Do players need to install an app?</h4>
        <p className="text-gray-700 mt-2">No, LeagueSphere is mobile-friendly and works directly in browsers.</p>
      </div>

      <div className="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
        <h4 className="font-semibold text-gray-900">⚡ What tournament formats are supported?</h4>
        <p className="text-gray-700 mt-2">We support knockout, league, round-robin, and even double round formats.</p>
      </div>

      <div className="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
        <h4 className="font-semibold text-gray-900">🏅 Can we generate winner certificates?</h4>
        <p className="text-gray-700 mt-2">Absolutely! Certificates for winners and top players are generated automatically.</p>
      </div>
    </div>
  </div>
</section>
  );
};

export default FaqSection;